import { render, staticRenderFns } from "./SettingsScreen.vue?vue&type=template&id=79ed6ebe&scoped=true&"
import script from "./SettingsScreen.vue?vue&type=script&lang=js&"
export * from "./SettingsScreen.vue?vue&type=script&lang=js&"
import style0 from "./SettingsScreen.vue?vue&type=style&index=0&id=79ed6ebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ed6ebe",
  null
  
)

export default component.exports